import classes from "./accountMenu.module.scss";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import PersonIcon from '@mui/icons-material/Person';
//import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import { Auth } from 'aws-amplify';
import config from "../../config";

interface AccountMenuProps {
  open: boolean
  onClose: () => void
}

export default function AccountMenu({open, onClose, ...props}:AccountMenuProps):JSX.Element {
  const menuItems = [
    {
      label: 'My account',
      action: {
        component: 'a',
        href: config.pageUrls.ACCOUNT_PAGE
      },
      icon: PersonIcon
    },
    /*{
      label: 'Order history',
      action: {
        component: 'a',
        href: config.pageUrls.ORDER_HISTORY_PAGE
      },
      icon: FeedIcon
    }*/
  ];

  const handleSignOut = async () => {
    try {
      await Auth.signOut();
      window.location.reload();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return <>
    <Drawer
      anchor="right"
      classes={{paper: classes.drawer}}
      variant="temporary"
      open={open}
      onClose={onClose}
    >
      <div className={'j-flex-row j-align-items-center'}>
        <Typography variant="h4" component="div" className={classes.drawerTitle}>Account</Typography>
        <div className={'j-flex-grow'}></div>
        <IconButton
          component="div"
          color="inherit"
          aria-label="close drawer"
          onClick={onClose}
          size="large">
          <CloseIcon fontSize="small"/>
        </IconButton>
      </div>
      <List>
        {menuItems.map((item, index) => (
        <ListItem key={item.label} disablePadding>
          <ListItemButton {...item.action}>
            <ListItemIcon>
              <item.icon />
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        </ListItem>
        ))}
        <ListItem key="sign out" disablePadding>
          <ListItemButton onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Sign out" />
          </ListItemButton>
        </ListItem>
      </List>




    </Drawer>
  </>

}